const installationInstructions = {
  intro: {
    currentStep: 'intro',
    headerIcon: 'arrowGrey',
    includeInstallationSteps: true,
    includePairingProcess: true,
    nextStep: 'ariaInstallationInstructions',
    nextStepName: 'instructions',
    prevStepName: 'https://return-to-app',
    primaryText: 'Congratulations on getting an Aria floodlight!',
    haloDeviceResource: require('@/assets/device-models/MO-SE-01/Aria_halo.png'),
    resource: require('@/assets/device-models/MO-SE-01/Momentum_Aria_Floodlight.png'),
    resourceType: 'image',
    secondaryText: 'To get your device up and running, we\'ll guide you through the ',
    continueButtonText: 'Start installation',
    alternateNextStep: {
      nextStep: 'letsGetStarted',
      nextStepName: 'instructions',
      title: 'Skip to pairing',
    },
  },
  ariaInstallationInstructions: {
    currentStep: 'ariaInstallationInstructions',
    headerIcon: 'arrowGrey',
    prevStepName: 'installationIntro',
    title: 'Installation instructions',
    secondaryText: [
      'Installation should be performed by a qualified electrician who is informed about the standards and technical requirements of the floodlight and its proper installation.',
      'To install your Aria floodlight you will need:',
    ],
    steps: [
      {
        icon: require('@/assets/device-models/MO-SE-01/floodlight-off.png'),
        title: 'Existing floodlight',
        description: 'An existing floodlight with a 4" round junction box that is properly waterproofed and completely sealed.'
      },
      {
        icon: require('@/assets/device-models/MO-SE-01/power-on.png'),
        title: 'Power',
        description: 'Voltage supplied to the Aria should be between 100-240VAC. Do NOT connect the Aria to a dimmer switch or timer.'
      },
      {
        icon: require('@/assets/device-models/MO-SE-01/build.png'),
        title: 'Location',
        description: 'Mounting location must be on a wall, between 6-10 feet from the ground.'
      }
    ],
    nextStep: 'removeExistingFloodlight',
    nextStepName: 'instructions',
    rightActionItem: {
      tx: 'common.skip',
      nextStep: 'letsGetStarted',
    },
    alternateNextStep: {
      nextStep: 'homeAdvisor',
      nextStepName: 'homeAdvisor',
      lastStep: 'ariaInstallationInstructions', // go back to this step when home advisor is closed
      title: 'Get installation help',
    },
  },
  removeExistingFloodlight: {
    currentStep: 'removeExistingFloodlight',
    headerIcon: 'arrowGrey',
    prevStep:'ariaInstallationInstructions',
    prevStepName: 'instructions',
    title: 'Remove existing floodlight',
    resourceType: 'video',
    resource: require('@/assets/device-models/MO-SE-01/Aria_Floodlight_Installation_Steps-1-3.mp4'),
    poster: require('@/assets/device-models/MO-SE-01/Aria_remove_existing_poster.png'),
    videoType: 'video/mp4',
    videoControls: 'controls',
    steps: [
      {
        title: 'Turn off power',
        stepNumber: 1,
        description: "Turn off all power to the installation site from your breaker box. Consult a licensed electrician if you’re unsure which switch to turn off."
      },
      {
        title: 'Remove existing floodlight',
        stepNumber: 2,
        description: 'Carefully disconnect the attached wires.'
      },
      {
        title: 'Remove mounting bracket',
        stepNumber: 3,
        description: 'Remove the existing floodlight’s mounting bracket. Install the mounting bracket included with your Aria. Pass the mounting base’s wires through the provided gasket.'
      }
    ],
    rightActionItem: {
      tx: 'common.skip',
      nextStep: 'letsGetStarted',
    },
    nextStep: 'installFloodlight',
    nextStepName: 'instructions',
    alternateNextStep: {
      nextStep: 'homeAdvisor',
      nextStepName: 'homeAdvisor',
      lastStep: 'removeExistingFloodlight', // go back to this step when home advisor is closed
      title: 'Get installation help',
    },
  },
  installFloodlight: {
    currentStep: 'installFloodlight',
    headerIcon: 'arrowGrey',
    prevStep:'removeExistingFloodlight',
    prevStepName: 'instructions',
    title: 'Install Aria floodlight',
    resourceType: 'video',
    resource: require('@/assets/device-models/MO-SE-01/Aria_Floodlight_Installation_Steps-4-6.mp4'),
    poster: require('@/assets/device-models/MO-SE-01/Aria_install_poster.png'),
    videoControls: 'controls',
    videoType: 'video/mp4',
    steps: [
      {
        title: 'Connect Wires',
        stepNumber: 4,
        description: "Using the provided wire nuts, connect the two ground wires together before doing the same with the black and white wires. Consult a licensed electrician if you're unsure which wires to connect."
      },
      {
        title: 'Secure Floodlight',
        stepNumber: 5,
        description: 'Tightly secure the mounting base, gasket and mounting bracket. Use the long bracket screw that is provided.'
      },
      {
        title: 'Mount Floodlight',
        stepNumber: 6,
        description: 'Snap Aria into the mounting plate before screwing it into place.'
      }
    ],
    nextStep: 'restorePower',
    nextStepName: 'instructions',
    rightActionItem: {
      tx: 'common.skip',
      nextStep: 'letsGetStarted',
    },
    alternateNextStep: {
      nextStep: 'homeAdvisor',
      nextStepName: 'homeAdvisor',
      lastStep: 'installFloodlight', // go back to this step when home advisor is closed
      title: 'Get installation help',
    },
  },
  restorePower: {
    currentStep: 'restorePower',
    headerIcon: 'arrowGrey',
    prevStep:'installFloodlight',
    prevStepName: 'instructions',
    title: 'Restore power',
    resourceType: 'video',
    resource: require('@/assets/device-models/MO-SE-01/Aria_Floodlight_Installation_Steps-7-8.mp4'),
    poster: require('@/assets/device-models/MO-SE-01/Aria_restore_power_poster.png'),
    videoType: 'video/mp4',
    videoControls: 'controls',
    steps: [
      {
        title: 'Restore Power',
        stepNumber: 7,
        description: 'Restore power to the installation site. The lights will come on and you will hear a confirmation as Aria boots up.'
      }
    ],
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    alternateNextStep: {
      nextStep: 'homeAdvisor',
      nextStepName: 'homeAdvisor',
      lastStep: 'restorePower', // go back to this step when home advisor is closed
      title: 'Get installation help',
    },
  },
  letsGetStarted: {
    currentStep: 'letsGetStarted',
    headerIcon: 'arrowGrey',
    prevStep: 'restorePower',
    prevStepName: 'instructions',
    resourceType: 'video',
    resource: require('@/assets/device-models/MO-SE-01/blinking_aria.mp4'),
    poster: require('@/assets/device-models/MO-SE-01/blinking_aria_poster.png'),
    videoAutoPlay: 'autoplay',
    videoType: 'video/mp4',
    videoLoop: 'loop',
    videoControls: false,
    primaryText: 'Verify device is in pairing mode',
    secondaryText: 'It may take a few minutes after powering on the floodlight before it is in pairing mode. Ways to verify:',
    steps: [
      {
        title: 'Voice confirmation',
        description: 'You will hear a voice confirmation from the floodlight when it is ready to pair.',
        stepNumber: 1
      },
      {
        title: 'Blinking light pattern',
        description: 'The light will also turn to a double blinking blue.',
        stepNumber: 2
      },
    ],
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      title: 'Read instructions',
    },
    continueButtonText: 'Ready',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
  },
  pairingModeReset: {
    headerIcon: 'arrowGrey',
    prevStep: 'letsGetStarted',
    prevStepName: 'instructions',
    currentStep: 'pairingModeReset',
    resourceType: 'image',
    resource: require('@/assets/device-models/MO-SE-01/Reset-Aria_back.png'),
    primaryText: 'Putting Aria into Pairing Mode',
    secondaryText: 'If the light on the front of the device is not double blinking blue, it is not in pairing mode. To manually put the Aria into pairing mode:',
    steps: [
      {
        stepNumber: 1,
        title: 'Remove screw',
        description: 'Remove the screw at the top of the camera housing and pull away from the fixture. Be careful not to disconnect any of the wires.',
      },
      {
        stepNumber: 2,
        title: 'Press and hold',
        description: 'Press and hold the button on the back of your device.',
      },
      {
        stepNumber: 3,
        title: 'Release button',
        description: 'Release the button as soon as you see the light on the front of the device turn solid red and the floodlights turn on.',
      },
      {
        stepNumber: 4,
        title: 'Voice confirmation',
        description: 'After the Aria finishes restarting, you will hear a voice confirmation indicating the device is ready to pair. The light on the front of the device will turn to double blinking blue.',
      },
      {
        stepNumber: 5,
        title: 'Secure Aria',
        description: 'Put Aria back onto the fixture and secure the camera housing with the screw.',
      },
    ],
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
  },
};

export default installationInstructions;
